import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpPinIconComponent from './adpPinIcon.component';

let adpPinIconModule = angular.module('adpPinIcon', [
  uiRouter
])

.component('adpPinIcon', adpPinIconComponent)

.name;

export default adpPinIconModule;



// WEBPACK FOOTER //
// ./src/app/components/adpPinIcon/adpPinIcon.js